export default __webpack_public_path__ + "static/media/logo.9dbd53c7.jpg";